import React from 'react'
import './DigiHealthLandingHero.css'

const DigiHealthLandingHero = () => {
  return (
    <section className="Digi-Health-Landing-hero-section-bg">
      <div className="Digi-Health-Landing-hero-section-badge">
        <span className="Digi-Health-Landing-hero-section-badge-text">
          Transforming Healthcare Through Innovation
        </span>
      </div>
      <h1 className="Digi-Health-Landing-hero-section-title">
        Driving Evidence-Based,<br />
        <span className="Digi-Health-Landing-hero-section-highlight">
          Inclusive, and Standardized
        </span><br />
        Digital Healthcare Transformation
      </h1>
      <p className="Digi-Health-Landing-hero-section-desc">
        DigiHealth India is an independent, non-governmental initiative empowering healthcare transformation through research, insights, advocacy, and collaboration across the Indian subcontinent.
      </p>
      <div className="Digi-Health-Landing-hero-section-btns">
        <a 
          target="_blank"
          rel="noopener noreferrer"
          href='mailto:info@digihealthindia.com'
          className="Digi-Health-Landing-hero-section-btn-primary"
        >
          Join the Movement
          <span className="Digi-Health-Landing-hero-section-btn-arrow">&rarr;</span>
        </a>
      </div>
    </section>
  )
}

export default DigiHealthLandingHero
